/* ==========================================================================
   Lockett Labs search page (sections/static-search.liquid)

   What search needs on top of the collection page's own script
   (ll-collection.js), which already runs the watch bells, add to cart,
   toasts, availability chips, the filter drawer, pills and grid or list:

     shortcuts    the row under the query: matching sets and collections,
                  related searches and help pages from Shopify's predictive
                  search, and the games a cross-game search spans
     did you mean for a search that finds little or nothing
     recent       the header's recent searches (ll_recent_searches), kept
                  up to date and offered on the start and no results pages
     search box   suggestions, keyboard and quick add on the start and no
                  results pages
     counts       availability chip numbers, the Coming soon chip and the
                  empty state, all from the filter engine's own state

   Everything here is an addition: with this file missing, the page still
   searches, filters, sorts and sells.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-lls-root]');
  if (!root) return;

  var MODE = root.getAttribute('data-lls-mode') || 'start';
  var Q = (root.getAttribute('data-lls-q') || '').trim();
  var TOTAL = parseInt(root.getAttribute('data-lls-total'), 10) || 0;
  var LIMIT = parseInt(root.getAttribute('data-lls-limit'), 10) || 6;
  var QUICK = root.getAttribute('data-lls-quick-add') === '1';
  var BASE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var RECENT_KEY = 'll_recent_searches';
  var THIN = 8;

  var IC_SEARCH = '<svg class="lls__ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.6"/><path d="m16 16 4.4 4.4"/></svg>';
  var IC_ARROW = '<svg class="lls__ic lls__ic--arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg>';
  var IC_PAGE = '<svg class="lls__ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5M10 13h6M10 17h6"/></svg>';
  var IC_CLOCK = '<svg class="lls__ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.2"/><path d="M12 7.6V12l3 2"/></svg>';
  var IC_GRID = '<svg class="lls__ic" viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="6.5" height="6.5" rx="1.2"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.2"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.2"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.2"/></svg>';

  /* ---- helpers --------------------------------------------------------- */

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(t) {
    return String(t || '').toLowerCase().replace(/[‘’']/g, '').replace(/\s+/g, ' ').trim();
  }
  function fmt(n) { return Number(n || 0).toLocaleString('en-GB'); }
  /* Every search this page links to sinks sold out products, as the forms do. */
  function searchUrl(q) {
    return BASE + 'search?type=product&options%5Bunavailable_products%5D=last&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
  }
  function img(src, w) {
    if (!src) return '';
    src = String(src).replace(/^\/\//, 'https://');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function money(v) {
    var n = Number(v);
    if (isNaN(n)) return '';
    /* suggest.json gives prices as decimal strings ("4.95"). */
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(n); }
    catch (e) { return '£' + n.toFixed(2); }
  }

  /* Optimal string alignment distance: Levenshtein plus a swap of two
     neighbours counting as one edit, which is the commonest typo there is
     ("piakchu" for "pikachu"). */
  function distance(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    if (!m) return n;
    if (!n) return m;
    for (i = 0; i <= m; i++) { d[i] = [i]; }
    for (j = 0; j <= n; j++) { d[0][j] = j; }
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[m][n];
  }

  /* Shopify's predictive search, one request per question, cached. */
  var cache = {};
  function suggest(q, types, limit) {
    var key = types + '|' + limit + '|' + norm(q);
    if (!cache[key]) {
      var url = BASE + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=' + types +
        '&resources%5Blimit%5D=' + limit +
        '&resources%5Blimit_scope%5D=each' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      cache[key] = fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return (d && d.resources && d.resources.results) || {}; })
        .catch(function () { return {}; });
    }
    return cache[key];
  }

  /* ---- recent searches ------------------------------------------------- */

  function readRecent() {
    try {
      var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Object.prototype.toString.call(v) === '[object Array]'
        ? v.filter(function (x) { return typeof x === 'string' && x.trim(); })
        : [];
    } catch (e) { return []; }
  }
  function writeRecent(list) {
    try {
      if (list.length) localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6)));
      else localStorage.removeItem(RECENT_KEY);
    } catch (e) {}
  }
  function pushRecent(q) {
    q = String(q || '').trim();
    if (q.length < 2) return;
    var list = readRecent().filter(function (x) { return norm(x) !== norm(q); });
    list.unshift(q);
    writeRecent(list);
  }
  function dropRecent(q) {
    writeRecent(readRecent().filter(function (x) { return norm(x) !== norm(q); }));
  }

  /* A search that found products is worth offering again, including one that
     arrived from a link rather than the header. One that found nothing is
     not: it would sit at the top of the list as the first thing to tap. */
  if (MODE === 'results' && Q) pushRecent(Q);
  if (MODE === 'none' && Q) dropRecent(Q);

  function paintRecent() {
    var box = root.querySelector('[data-lls-recent]');
    var list = box && box.querySelector('[data-lls-recent-list]');
    if (!box || !list) return;
    var items = readRecent().filter(function (x) { return norm(x) !== norm(Q); });
    list.innerHTML = items.map(function (x) {
      return '<li><a class="lls__chip lls__chip--recent" href="' + esc(searchUrl(x)) + '">' + IC_CLOCK + esc(x) + '</a></li>';
    }).join('');
    box.hidden = items.length === 0;
  }
  root.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-lls-recent-clear]')) return;
    writeRecent([]);
    paintRecent();
  });
  paintRecent();

  /* ---- did you mean ---------------------------------------------------- */

  /* Shopify already forgives most typos, so this only runs when a search
     came back thin or empty. Candidates are Shopify's own query suggestions,
     for the whole query and then for shorter and shorter starts of it (a
     typo usually sits after the first few letters, and "pi" still suggests
     "pikachu" where "piakchu" suggests nothing). The closest one by edit
     distance wins, if it is close enough to be the same word misspelt. */
  function didYouMean() {
    var nq = norm(Q);
    if (nq.length < 3 || /\d/.test(nq)) return Promise.resolve(null);
    var words = nq.split(' ').length;
    var max = nq.length <= 4 ? 1 : nq.length <= 8 ? 2 : 3;
    var probes = [nq];
    var half = nq.slice(0, Math.max(3, Math.ceil(nq.length / 2)));
    if (half !== nq) probes.push(half);
    if (nq.length > 2) probes.push(nq.slice(0, 2));

    var best = null;
    function consider(results) {
      (results.queries || []).forEach(function (s) {
        var t = norm(s.text).split(' ').slice(0, words).join(' ');
        if (!t || t === nq) return;
        var d = distance(t, nq);
        if (d > 0 && d <= max && (!best || d < best.d)) best = { text: t, d: d };
      });
    }
    function next(i) {
      if (i >= probes.length || (best && best.d === 1)) return Promise.resolve(best);
      return suggest(probes[i], 'query', 10).then(function (r) { consider(r); return next(i + 1); });
    }
    return next(0);
  }

  /* ---- the shortcuts row (results) -------------------------------------- */

  function jumpItem(html, cls) {
    var li = document.createElement('li');
    li.className = 'lls__jump-new';
    li.innerHTML = html;
    if (cls) li.firstChild.className += ' ' + cls;
    return li;
  }

  function buildJump() {
    var track = root.querySelector('[data-lls-jump-track]');
    if (!track || !Q) return;
    var tip = track.querySelector('[data-lls-jump-tip]');
    var firstGame = track.querySelector('[data-lls-game]');
    var gameLi = firstGame ? firstGame.parentNode : null;
    var have = {};
    track.querySelectorAll('[data-lls-coll]').forEach(function (a) { have[a.getAttribute('data-lls-coll')] = 1; });

    var jobs = [suggest(Q, 'collection,query,page,article', 4)];
    if (TOTAL < THIN) jobs.push(didYouMean());

    Promise.all(jobs).then(function (out) {
      var res = out[0] || {};
      var dym = out[1] || null;
      var added = 0;

      if (dym) {
        track.insertBefore(jumpItem(
          '<a class="lls__jc lls__jc--dym" href="' + esc(searchUrl(dym.text)) + '"><span>Did you mean <b>' + esc(dym.text) + '</b>?</span></a>'
        ), track.firstChild);
        added++;
      }

      /* Sets and collections go straight after anything the server found,
         and before the game chips: they are a place to go, the games are a
         filter over what is already here. */
      (res.collections || []).slice(0, 3).forEach(function (c) {
        if (!c || have[c.handle] || !c.url) return;
        have[c.handle] = 1;
        var pic = c.featured_image && c.featured_image.url
          ? '<img src="' + esc(img(c.featured_image.url, 72)) + '" alt="" width="36" height="24" decoding="async">'
          : '<span class="lls__jc-mark" aria-hidden="true">' + IC_GRID + '</span>';
        var li = jumpItem('<a class="lls__jc lls__jc--coll" href="' + esc(c.url) + '" data-lls-coll="' + esc(c.handle) + '">' +
          pic + '<span>' + esc(c.title) + '</span>' + IC_ARROW + '</a>');
        track.insertBefore(li, gameLi || tip || null);
        added++;
      });

      var seen = {};
      seen[norm(Q)] = 1;
      if (dym) seen[dym.text] = 1;
      (res.queries || []).forEach(function (s) {
        var t = String(s.text || '').trim();
        if (!t || seen[norm(t)] || added > 9) return;
        seen[norm(t)] = 1;
        track.insertBefore(jumpItem('<a class="lls__jc lls__jc--q" href="' + esc(searchUrl(t)) + '">' + IC_SEARCH + '<span>' + esc(t) + '</span></a>'), tip || null);
        added++;
      });

      (res.pages || []).concat(res.articles || []).slice(0, 2).forEach(function (p) {
        if (!p || !p.url) return;
        track.insertBefore(jumpItem('<a class="lls__jc lls__jc--page" href="' + esc(p.url) + '">' + IC_PAGE + '<span>' + esc(p.title) + '</span></a>'), tip || null);
        added++;
      });

      if (added && tip) tip.parentNode.removeChild(tip);
      if (added) root.querySelector('[data-lls-jump]').classList.add('is-rich');
      syncJumpFade();
    });
  }

  /* A fade on the right edge only while there is more to scroll to. */
  function syncJumpFade() {
    var nav = root.querySelector('[data-lls-jump]');
    var track = nav && nav.querySelector('[data-lls-jump-track]');
    if (!track) return;
    var more = track.scrollWidth - track.clientWidth - track.scrollLeft > 4;
    nav.classList.toggle('has-more', more);
    nav.classList.toggle('is-scrolled', track.scrollLeft > 4);
  }
  (function () {
    var track = root.querySelector('[data-lls-jump-track]');
    if (!track) return;
    track.addEventListener('scroll', syncJumpFade, { passive: true });
    window.addEventListener('resize', syncJumpFade);
    syncJumpFade();
  }());

  /* Game chips: one tap keeps only that game, through the engine's own
     Category facet, so the panel, the pills and the URL all agree. Until the
     engine is up they are plain links to the game's page, searched. */
  root.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-lls-game]');
    if (!chip) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var v = chip.getAttribute('data-lls-game');
    var box = document.querySelector('.llf [data-llf-opts="game"] .llf__opt[data-value="' + v + '"] input');
    if (!box) return;
    e.preventDefault();
    var others = document.querySelectorAll('.llf [data-llf-opts="game"] .llf__opt input');
    var turnOn = !box.checked;
    for (var i = 0; i < others.length; i++) {
      var want = turnOn && others[i] === box;
      if (others[i].checked !== want) {
        others[i].checked = want;
        others[i].dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  /* ---- engine state: chip counts, Coming soon, empty state, games ------ */

  var comingShown = false;
  document.addEventListener('ll:filter:state', function (e) {
    var d = e.detail || {};
    var counts = d.counts || {};
    var av = counts.availability || {};
    var sel = d.selection || {};

    ['in', 'out', 'coming'].forEach(function (k) {
      var el = root.querySelector('[data-lls-avail-n="' + k + '"]');
      if (el) el.textContent = typeof av[k] === 'number' ? ' ' + fmt(av[k]) : '';
    });

    var coming = root.querySelector('[data-lls-coming]');
    if (coming && (av.coming > 0 || (sel.availability || []).indexOf('coming') > -1)) {
      coming.hidden = false;
      comingShown = true;
    } else if (coming && !comingShown) {
      coming.hidden = true;
    }

    var empty = root.querySelector('[data-empty]');
    if (empty) empty.setAttribute('data-show', d.total === 0 ? '1' : '0');

    /* The state's counts are keyed by the index's dictionary position, not by
       the value, so each game's number is read from its row in the panel,
       which the engine has just drawn from the same answer. */
    var chosen = sel.game || [];
    root.querySelectorAll('[data-lls-game]').forEach(function (chip) {
      var v = chip.getAttribute('data-lls-game');
      var n = chip.querySelector('[data-lls-game-n]');
      var row = document.querySelector('.llf [data-llf-opts="game"] .llf__opt[data-value="' + v + '"] .llf__n');
      if (n) n.textContent = row ? row.textContent.trim() : '';
      chip.setAttribute('aria-pressed', chosen.indexOf(v) > -1 ? 'true' : 'false');
    });
    syncJumpFade();
  });

  root.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-lls-clear-filters]')) return;
    var clear = document.querySelector('.llf [data-llf-clear]');
    if (clear) clear.click();
  });

  /* ---- the search box (start, no results) ------------------------------ */

  function bindBox() {
    var box = root.querySelector('[data-lls-box]');
    if (!box) return;
    var form = box.querySelector('[data-lls-form]');
    var input = box.querySelector('[data-lls-input]');
    var clear = box.querySelector('[data-lls-clear]');
    var list = box.querySelector('[data-lls-suggest]');
    if (!form || !input || !list) return;

    var timer = null;
    var seq = 0;
    var active = -1;

    function options() { return list.querySelectorAll('[role="option"]'); }
    function setActive(i) {
      var opts = options();
      if (!opts.length) { active = -1; input.removeAttribute('aria-activedescendant'); return; }
      if (i < 0) i = opts.length - 1;
      if (i >= opts.length) i = 0;
      active = i;
      for (var k = 0; k < opts.length; k++) opts[k].setAttribute('aria-selected', k === i ? 'true' : 'false');
      input.setAttribute('aria-activedescendant', opts[i].id);
      opts[i].scrollIntoView({ block: 'nearest' });
    }
    function open() {
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      box.classList.add('is-open');
    }
    function close() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      box.classList.remove('is-open');
      active = -1;
    }
    function mark(text, q) {
      var t = String(text || '');
      var i = t.toLowerCase().indexOf(String(q || '').toLowerCase());
      if (!q || i < 0) return esc(t);
      return esc(t.slice(0, i)) + '<b>' + esc(t.slice(i, i + q.length)) + '</b>' + esc(t.slice(i + q.length));
    }
    function stateOf(p) {
      var tags = (p.tags || []).join(',').toLowerCase();
      if (p.available === false) {
        if (tags.indexOf('coming') > -1) return { key: 'coming', label: 'Coming soon' };
        if (tags.indexOf('pre-order') > -1 || tags.indexOf('preorder') > -1) return { key: 'coming', label: 'Allocation pending' };
        return { key: 'soldout', label: 'Sold out' };
      }
      if (tags.indexOf('pre-order') > -1 || tags.indexOf('preorder') > -1) return { key: 'preorder', label: 'Pre-order' };
      return { key: 'instock', label: 'In stock' };
    }

    function render(q, res) {
      var n = 0;
      var html = '';
      var queries = (res.queries || []).filter(function (s) { return norm(s.text) !== norm(q); }).slice(0, 4);
      var colls = (res.collections || []).slice(0, 3);
      var prods = (res.products || []).slice(0, LIMIT);

      if (queries.length) {
        html += '<p class="lls__sg-h" aria-hidden="true">Searches</p><ul class="lls__sg-queries" role="group" aria-label="Searches">';
        queries.forEach(function (s) {
          html += '<li role="none"><a role="option" id="lls-o-' + (n++) + '" class="lls__sg-q" href="' + esc(searchUrl(s.text)) + '">' + IC_SEARCH + '<span>' + mark(s.text, q) + '</span></a></li>';
        });
        html += '</ul>';
      }
      if (colls.length) {
        html += '<p class="lls__sg-h" aria-hidden="true">Sets and collections</p><ul class="lls__sg-colls" role="group" aria-label="Sets and collections">';
        colls.forEach(function (c) {
          var pic = c.featured_image && c.featured_image.url ? '<img src="' + esc(img(c.featured_image.url, 96)) + '" alt="" width="48" height="32" loading="lazy">' : '<span class="lls__jc-mark">' + IC_GRID + '</span>';
          html += '<li role="none"><a role="option" id="lls-o-' + (n++) + '" class="lls__sg-c" href="' + esc(c.url) + '">' + pic + '<span>' + mark(c.title, q) + '</span>' + IC_ARROW + '</a></li>';
        });
        html += '</ul>';
      }
      if (prods.length) {
        html += '<p class="lls__sg-h" aria-hidden="true">Products</p><ul class="lls__sg-prods" role="group" aria-label="Products">';
        prods.forEach(function (p) {
          var st = stateOf(p);
          /* Predictive search sends an empty variants list, so the button
             carries the handle and finds its variant when it is pressed. */
          var quick = QUICK && st.key === 'instock' && p.handle;
          var pic = p.image || (p.featured_image && p.featured_image.url) || '';
          html += '<li class="lls__sg-p" role="none">' +
            '<a role="option" id="lls-o-' + (n++) + '" href="' + esc(p.url) + '">' +
              (pic ? '<img src="' + esc(img(pic, 96)) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="lls__sg-noimg"></span>') +
              '<span class="lls__sg-t"><span>' + mark(p.title, q) + '</span>' +
              '<span class="lls__sg-meta"><b>' + esc(money(p.price)) + '</b><i data-s="' + st.key + '">' + st.label + '</i></span></span>' +
            '</a>' +
            (quick ? '<button type="button" class="lls__sg-add" data-lls-quick="' + esc(p.handle) + '" aria-label="Add ' + esc(p.title) + ' to cart"><span class="llc__btn-full">Add</span><span class="llc__btn-short">Add</span></button>' : '') +
          '</li>';
        });
        html += '</ul>';
      }
      if (!n) {
        html += '<p class="lls__sg-none">No quick matches. Press Search to look through everything.</p>';
      }
      html += '<button type="button" class="lls__sg-all" data-lls-all>' + IC_SEARCH + '<span>Search for <b>“' + esc(q) + '”</b></span>' + IC_ARROW + '</button>';
      list.innerHTML = html;
      active = -1;
      open();
    }

    function run() {
      var q = input.value.trim();
      if (clear) clear.hidden = !input.value;
      if (q.length < 2) { close(); list.innerHTML = ''; return; }
      var my = ++seq;
      suggest(q, 'product,collection,query', Math.max(LIMIT, 4)).then(function (res) {
        if (my !== seq || document.activeElement !== input) return;
        render(q, res);
      });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 160);
      if (clear) clear.hidden = !input.value;
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && list.innerHTML) open();
    });
    input.addEventListener('keydown', function (e) {
      var opts = options();
      if (e.key === 'ArrowDown') { if (list.hidden) run(); else setActive(active + 1); e.preventDefault(); }
      else if (e.key === 'ArrowUp') { if (!list.hidden) { setActive(active - 1); e.preventDefault(); } }
      else if (e.key === 'Escape') { if (!list.hidden) { close(); e.preventDefault(); } }
      else if (e.key === 'Enter' && active > -1 && opts[active]) {
        e.preventDefault();
        opts[active].click();
      }
    });
    /* Quick add from a suggestion. The first press looks the product up; a
       single variant in stock is then added through the collection script's
       own add to cart (the same toast, count and button states as the cards),
       and anything with options goes to its page to choose them. Once the
       variant is known the button carries data-atc, so later presses go
       straight to that handler. */
    list.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-lls-quick]');
      if (!btn || btn.hasAttribute('data-atc')) return;
      e.preventDefault();
      if (btn.disabled) return;
      var handle = btn.getAttribute('data-lls-quick');
      var page = BASE + 'products/' + handle;
      btn.disabled = true;
      btn.classList.add('is-busy');
      fetch(page + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var vs = (p && p.variants) || [];
          if (vs.length !== 1 || !vs[0].available || !window.LLCollection) { location.href = page; return; }
          btn.setAttribute('data-atc', String(vs[0].id));
          btn.disabled = false;
          btn.classList.remove('is-busy');
          window.LLCollection.atc(btn);
        })
        .catch(function () { location.href = page; });
    });
    list.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-lls-all]')) {
        e.preventDefault();
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      }
    });
    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        clear.hidden = true;
        close();
        input.focus();
      });
    }
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); input.focus(); return; }
      pushRecent(q);
      close();
    });
    document.addEventListener('click', function (e) {
      if (list.hidden) return;
      if (e.target.closest && e.target.closest('[data-lls-box]')) return;
      close();
    });

    /* The start page is for searching: put the caret in the box. Not on a
       touch screen, where it would throw the keyboard over the page, and not
       on no results, where the query is already there to read first. */
    if (MODE === 'start' && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
    }
  }

  /* ---- no results: did you mean, with how much it finds ----------------- */

  function noResults() {
    var line = root.querySelector('[data-lls-dym]');
    if (!line || !Q) return;
    didYouMean().then(function (best) {
      if (!best) return;
      /* How many products the suggestion finds, from the same handle feed
         the filter engine uses: a promise worth tapping is one with a
         number on it. */
      return fetch(BASE + 'search?q=' + encodeURIComponent(best.text) + '&view=handles&type=product&options%5Bunavailable_products%5D=last', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (feed) {
          var n = feed && feed.total ? feed.total : 0;
          line.innerHTML = 'Did you mean <a href="' + esc(searchUrl(best.text)) + '">' + esc(best.text) + '</a>?' +
            (n ? ' <span>' + fmt(n) + ' product' + (n === 1 ? '' : 's') + '</span>' : '');
          line.classList.add('is-on');
        });
    });
  }

  /* ---- boot ------------------------------------------------------------ */

  if (MODE === 'results') buildJump();
  if (MODE === 'none') noResults();
  bindBox();
}());
